import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { serviceKeywords } from './utils/seoKeywords'; 

const SEOManager = () => {
  const location = useLocation();

  useEffect(() => {
    const pathParts = location.pathname.split('/').filter(Boolean);
    const slug = pathParts.length > 0 ? pathParts[pathParts.length - 1] : 'home';

    const data = serviceKeywords[slug] || serviceKeywords['default'];

    if (data) {
      // 1. Title թարմացում
      document.title = `${data.hy[0]} | Liber Group`;

      // 2. Meta Helper ֆունկցիա (որ կոդը չկրկնվի)
      const updateMeta = (name, content, isProperty = false) => {
        const selector = isProperty ? `meta[property="${name}"]` : `meta[name="${name}"]`;
        let element = document.querySelector(selector);
        if (!element) {
          element = document.createElement('meta');
          if (isProperty) element.setAttribute('property', name);
          else element.name = name;
          document.head.appendChild(element);
        }
        element.content = content;
      };

      // 3. Description & Keywords
      const descText = `${data.hy[0]} Երևանում և Հայաստանում: ${data.slang.slice(0, 5).join(', ')}. Լավագույն գինն ու որակը միայն Liber Group-ում:`;
      updateMeta('description', descText);
      updateMeta('keywords', [...data.hy, ...data.en, ...data.ru, ...data.slang].join(', '));

      // 4. Open Graph (Social Media-ի համար)
      updateMeta('og:title', `${data.hy[0]} | Liber Group`, true);
      updateMeta('og:description', descText, true);
      updateMeta('og:url', window.location.href, true);
      updateMeta('og:type', 'website', true);

      // 5. Canonical Link թարմացում
      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.rel = 'canonical';
        document.head.appendChild(canonical);
      }
      canonical.href = window.location.href;
    }
  }, [location]);

  return null;
};

export default SEOManager;